import * as api from '../utils/api.js';

/**
 * Guest auth middleware.
 * Used for routes that require user to NOT be authenticated (guest session).
 * Useful for pages such as login, register, ...
 */
export default defineNuxtRouteMiddleware(async () => {
  const store = useWebsiteStore();

  // Logout user if was already authenticated
  if (store.userInfo) {
    await api.logout();
  }
});
